import { adminAppointmentByStatus } from "../../../config/service";
import { PAGE_SIZE } from "./meetingDetailsConstants";

/**
 * AG Grid Infinite Row Model datasource: one block = one server page (PAGE_SIZE rows).
 * Request context is read from `requestRef.current` on each call (search, sort, filters).
 */
export function createMeetingListDatasource(
  statusType,
  requestRef,
  { onLoaded, setSectionLoading }
) {
  return {
    getRows(params) {
      const startRow = params.startRow;
      const endRow = params.endRow;
      const ctx = requestRef.current;
      if (!ctx?.mapMeetingData) {
        params.failCallback();
        return;
      }

      const blockSize = endRow - startRow;
      if (blockSize <= 0) {
        params.successCallback([], 0);
        return;
      }

      const page = Math.floor(startRow / PAGE_SIZE) + 1;
      const filters = ctx.columnFiltersRef?.current?.[statusType];
      const trimmed = ctx.search ?? "";
      const colFilters =
        filters && typeof filters === "object" && Object.keys(filters).length > 0
          ? filters
          : undefined;

      setSectionLoading?.(true);

      adminAppointmentByStatus({
        statuses: statusType,
        allMeeting: ctx.allMeeting === true,
        page,
        perPage: PAGE_SIZE,
        sortField: ctx.sortField,
        sortDir: ctx.sortDir,
        ...(trimmed ? { search: trimmed } : {}),
        ...(colFilters ? { filters: colFilters } : {}),
      })
        .then((response) => {
          const raw = response?.data?.result;
          const allMapped = ctx.mapMeetingData(raw).filter(Boolean);

          const hidden = ctx.hiddenRowIds?.current;
          const mapped = hidden?.size > 0
            ? allMapped.filter((r) => !hidden.has(String(r["Meeting Id"])))
            : allMapped;
          const hiddenInBlock = allMapped.length - mapped.length;

          const serverTotal = response?.data?.totalCount ?? 0;
          const adjustedTotal = Math.max(0, serverTotal - hiddenInBlock);
          const totalPages = response?.data?.totalPages ?? 1;

          const isIncompleteBlock = mapped.length < blockSize;
          const lastRow = isIncompleteBlock
            ? startRow + mapped.length
            : adjustedTotal > 0
              ? adjustedTotal
              : -1;

          onLoaded?.({
            rows: mapped,
            totalCount: isIncompleteBlock ? startRow + mapped.length : adjustedTotal,
            totalPages,
            page,
          });

          params.successCallback(mapped, lastRow);
        })
        .catch(() => {
          params.failCallback();
        })
        .finally(() => {
          setSectionLoading?.(false);
        });
    },
  };
}
